import React from "react";
import { useTranslation } from "react-i18next";
import { baseContainer } from "@base-provider";
import SFDialog from "../dialog";

const LogoutConfirmation = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <SFDialog
      variant="default"
      title={t("components.logoutDialog.header")}
      message={t("components.logoutDialog.bodyText")}
      open={true}
      onClose={onClose}
      primaryButton
      primaryButtonProps={{
        onClick: () => {
          onClose();
          baseContainer.authenticationService.logout();
        },
      }}
      secondaryButton
      secondaryButtonProps={{
        onClick: onClose,
      }}
    />
  );
};

export default LogoutConfirmation;
